"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.honeybadgerConfig = exports.Honeybadger = void 0;
var _react = require("react");
var _honeybadger = _interopRequireDefault(require("@honeybadger-io/js/dist/browser/honeybadger"));
var _ = require("./..");
var _env = require("../../config/env");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var apiKey = process.env.REACT_APP_HONEYBADGER_API_KEY;
var honeybadgerConfig = {
  apiKey: apiKey,
  environment: process.env.REACT_APP_ENVIRONMENT,
  reportData: true // allow non-prod environments to send data to Honeybadger. (https://docs.honeybadger.io/lib/javascript/reference/configuration/)
};
exports.honeybadgerConfig = honeybadgerConfig;
var Honeybadger = function Honeybadger() {
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  (0, _react.useEffect)(function () {
    if (!_honeybadger.default) {
      return;
    }
    _honeybadger.default.setContext({
      user_id: user === null || user === void 0 ? void 0 : user.accountId,
      tag: _env.Env.version.tag,
      branch: _env.Env.version.branch,
      commit: _env.Env.version.commit
    });
  }, [user]);

  // the script itself is connected in index.html because of the react-helmet issue https://github.com/nfl/react-helmet/issues/328
  // the issue makes impossible to track script loading with Helmet API so there is no sense to use Helmet in this case
  return null;
};
exports.Honeybadger = Honeybadger;